import React from 'react';
import createService from '../containers/CounselorCommunityMicro/embedService';

const closeModalsOptions = {
  showUserModal: null,
  showCollegeModal: null,
  showHighschoolModal: null,
  userId: null,
  collegeId: null,
  highschoolId: null,
  idType: null,
};

export const renderUserProfileModal = (showUserModal, uuid, props, closeModals, openInstitutionProfileModal) => {
  if (!showUserModal) return null;
  const UserProfileModal = global.CounselorCommunity?.default?.UserProfileModal;
  /* istanbul ignore next */
  const handleEditButton = () => {
    props.router.push('/counselorcommunity/profile/edit');
    window.dispatchEvent(new Event('counselor-community-serverless-update-route'));
    closeModals(closeModalsOptions);
  };

  return !!UserProfileModal && (
    <UserProfileModal
      {...props}
      embedService={createService(props)}
      baseUrl={process.env.COUNSELOR_COMMUNITY_API}
      userId={uuid}
      onInstitutionClick={openInstitutionProfileModal}
      handleEditButton={handleEditButton}
      onClose={/* istanbul ignore next */() => closeModals(closeModalsOptions)}
    />
  );
};

export const renderHEInstitutionProfileModal = (showCollegeModal, idType, collegeId, props, closeModals, handleViewStaff) => {
  if (!showCollegeModal) return null;

  const HEInstitutionProfileModal = global.CounselorCommunity?.default?.HEInstitutionProfileModal;
  return !!HEInstitutionProfileModal && (
    <HEInstitutionProfileModal
      {...props}
      embedService={createService(props)}
      baseUrl={process.env.COUNSELOR_COMMUNITY_API}
      collegeId={collegeId}
      idType={idType}
      handleViewStaff={handleViewStaff}
      onClose={/* istanbul ignore next */() => closeModals(closeModalsOptions)}
    />
  );
};
